export const channels = [
    {
      uuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
 
  ];
  